import { useNavigation } from '../context/NavigationContext';

export const useNavigationHandler = () => {
  const { setPageDestination } = useNavigation();

  const handleNavClick = (page, slug = null) => {
    setPageDestination(page, slug);
  };

  return { handleNavClick };
}; 